import { useT } from '@powerportalspro/react';
import { TabPanel, Tabs } from '@powerportalspro/react-fluent';
import { useState } from 'react';

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.Tabs.TabsMainDemo';
const MOUNTED_AT = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.Tabs.TabsMountedAt.mounted-at';

// The time its panel was first shown: it stays the same as the tabs are switched, because a panel
// stays mounted.
function MountedAt() {
  const t = useT();
  const [mountedAt] = useState(() => new Date().toLocaleTimeString());
  return (
    <p>
      <em>{t(MOUNTED_AT, [mountedAt])}</em>
    </p>
  );
}

export function TabsMainSample() {
  const t = useT();
  return (
    <Tabs selectedTabQueryParameter="tab">
      <TabPanel value="overview" header={t(`${STRINGS_BASE}.overview-header`)}>
        <p>{t(`${STRINGS_BASE}.overview-body`)}</p>
        <MountedAt />
      </TabPanel>
      <TabPanel value="contacts" header={t(`${STRINGS_BASE}.contacts-header`)}>
        <p>{t(`${STRINGS_BASE}.contacts-body`)}</p>
        <MountedAt />
      </TabPanel>
      <TabPanel value="documents" header={t(`${STRINGS_BASE}.documents-header`)}>
        <p>{t(`${STRINGS_BASE}.documents-body`)}</p>
        <MountedAt />
      </TabPanel>
      <TabPanel value="archive" header={t(`${STRINGS_BASE}.archive-header`)} disabled>
        <p>{t(`${STRINGS_BASE}.archive-body`)}</p>
      </TabPanel>
    </Tabs>
  );
}
